import React from 'react';
import { MarkerF } from '@react-google-maps/api';

export const RouteMarker = ({ position, type }) => {
  const getIcon = () => {
    switch (type) {
      case 'origin':
        return {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: '#10B981',
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 2,
          scale: 8
        };
      case 'destination':
        return {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: '#EF4444',
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 2,
          scale: 8
        };
      default:
        return {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: '#F59E0B',
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 2,
          scale: 6
        };
    }
  };

  return (
    <MarkerF
      position={position}
      icon={getIcon()}
      zIndex={type === 'origin' ? 3 : type === 'destination' ? 2 : 1}
    />
  );
};

export default RouteMarker;